import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";

const CONCEPT_CATEGORIES = [
  "CREDITOS",
  "CANJES",
  "LOTES",
  "MAYOR VALOR",
  "OFICINA",
  "PERMUTAS",
  "SUBSIDIOS",
] as const;

type Props = {
  companyName?: string;
  masterProjectName?: string;
  projectName?: string;
  projectId?: string;
  excludedCategories: string[];
  onToggleCategory: (category: string) => void;
  onLoadOverdueSales: () => void;
  isLoading?: boolean;
};

const RecaudoSummary = ({
  companyName,
  masterProjectName,
  projectName,
  projectId,
  excludedCategories,
  onToggleCategory,
  onLoadOverdueSales,
  isLoading,
}: Props) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Resumen</CardTitle>
        <CardDescription>
          Revisa la configuración antes de cargar las ventas en mora
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <dl className="space-y-2 text-sm">
          {companyName && (
            <div>
              <dt className="text-gray-500">Empresa</dt>
              <dd className="font-medium">{companyName}</dd>
            </div>
          )}
          {masterProjectName && (
            <div>
              <dt className="text-gray-500">Macroproyecto</dt>
              <dd className="font-medium">{masterProjectName}</dd>
            </div>
          )}
          {projectName && (
            <div>
              <dt className="text-gray-500">Proyecto</dt>
              <dd className="font-medium">{projectName}</dd>
            </div>
          )}
          <div>
            <dt className="text-gray-500 mb-2 block">Conceptos excluidos</dt>
            <dd className="flex flex-wrap gap-x-4 gap-y-2">
              {CONCEPT_CATEGORIES.map((cat) => (
                <label
                  key={cat}
                  className="flex items-center gap-2 cursor-pointer text-sm font-medium"
                >
                  <Checkbox
                    checked={excludedCategories.includes(cat)}
                    onCheckedChange={() => onToggleCategory(cat)}
                  />
                  <span>{cat}</span>
                </label>
              ))}
            </dd>
            <p className="text-xs text-gray-500 mt-1">
              Los campos marcados serán excluidos del cálculo de ventas en mora
            </p>
          </div>
        </dl>
        <Button onClick={onLoadOverdueSales} disabled={!projectId || isLoading}>
          {isLoading && <Loader2 className="mr-2 size-4 animate-spin" />}
          {isLoading ? "Cargando ventas..." : "Cargar ventas en mora"}
        </Button>
      </CardContent>
    </Card>
  );
};

export default RecaudoSummary;
